import { render, staticRenderFns } from "./page-bottom.vue?vue&type=template&id=19e2ccee"
import script from "./page-bottom.vue?vue&type=script&lang=js"
export * from "./page-bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports